export class RewardVoucherDM {
  constructor({
    is_quantity = "",
    additional_info = "",
    additional_info_link = "",
    brochure = "",
    category = {},
    contact_details = {},
    description = "",
    description_ind = "",
    display_img_url = "",
    how_to = {},
    how_to_use = "",
    is_voucher_available = "",
    locations = [],
    merchant = {},
    more_info = "",
    more_information = {},
    name = "",
    other_information = "",
    overview = {},
    options = {},
    points = "",
    points_label = "",
    quantity = "",
    redeemable = "",
    redemption_type = "",
    terms_and_conditions = "",
    terms_and_conditions_ind = "",
    thumbnail_img_url = "",
    tier = "",
    valid_from = "",
    valid_until = "",
    website = "",
  }) {
    this.is_quantity = is_quantity;
    this.additional_info = additional_info;
    this.additional_info_link = additional_info_link;
    this.brochure = brochure;
    this.category = category;
    this.contact_details = contact_details;
    this.description = description;
    this.description_ind = description_ind;
    this.display_img_url = display_img_url;
    this.how_to = how_to;
    this.how_to_use = how_to_use;
    this.is_voucher_available = is_voucher_available;
    this.locations = locations;
    this.merchant = merchant;
    this.more_info = more_info;
    this.more_information = more_information;
    this.name = name;
    this.other_information = other_information;
    this.overview = overview;
    this.options = options;
    this.points = points;
    this.points_label = points_label;
    this.quantity = quantity;
    this.redeemable = redeemable;
    this.redemption_type = redemption_type;
    this.terms_and_conditions = terms_and_conditions;
    this.terms_and_conditions_ind = terms_and_conditions_ind;
    this.thumbnail_img_url = thumbnail_img_url;
    this.tier = tier;
    this.valid_from = valid_from;
    this.valid_until = valid_until;
    this.website = website;
  }

  toJson() {
    return {
      additional_info: this.additional_info,
      is_quantity: this.is_quantity,
      additional_info_link: this.additional_info_link,
      brochure: this.brochure,
      category: this.category,
      contact_details: this.contact_details,
      description: this.description,
      description_ind: this.description_ind,
      display_img_url: this.display_img_url,
      how_to: this.how_to,
      how_to_use: this.how_to_use,
      is_voucher_available: this.is_voucher_available,
      locations: this.locations,
      merchant: this.merchant,
      more_info: this.more_info,
      more_information: this.more_information,
      name: this.name,
      other_information: this.other_information,
      overview: this.overview,
      options: this.options,
      points: this.points,
      points_label: this.points_label,
      quantity: this.quantity,
      redeemable: this.redeemable,
      redemption_type: this.redemption_type,
      terms_and_conditions: this.terms_and_conditions,
      terms_and_conditions_ind: this.terms_and_conditions_ind,
      thumbnail_img_url: this.thumbnail_img_url,
      tier: this.tier,
      valid_from: this.valid_from,
      valid_until: this.valid_until,
      website: this.website,
    };
  }

  static fromJson(json) {
    return new RewardVoucherDM({
      email: json["email"],
      is_quantity: json["is_quantity"],
      additional_info: json["additional_info"],
      additional_info_link: json["additional_info_link"],
      brochure: json["brochure"],
      category: json["category"],
      contact_details: json["contact_details"],
      description: json["description"],
      description_ind: json["description_ind"],
      display_img_url: json["display_img_url"],
      how_to: json["how_to"],
      how_to_use: json["how_to_use"],
      is_voucher_available: json["is_voucher_available"],
      locations: json["locations"],
      merchant: json["merchant"],
      more_info: json["more_info"],
      more_information: json["more_information"],
      name: json["name"],
      other_information: json["other_information"],
      overview: json["overview"],
      options: json["options"],
      points: json["points"],
      points_label: json["points_label"],
      quantity: json["quantity"],
      redeemable: json["redeemable"],
      redemption_type: json["redemption_type"],
      terms_and_conditions: json["terms_and_conditions"],
      terms_and_conditions_ind: json["terms_and_conditions_ind"],
      thumbnail_img_url: json["thumbnail_img_url"],
      tier: json["tier"],
      valid_from: json["valid_from"],
      valid_until: json["valid_until"],
      website: json["websit"],
    });
  }
}
